import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start();

// Vehicle dropdown lookups. Answers are kept for the life of the page, so
// picking the same option again doesn't ask the server twice. The REST route is
// cacheable and loads only this plugin; if a host blocks /wp-json, it falls back
// to admin-ajax once.
const boughtoLookups = new Map();
const boughtoLookupActions = {
    models: ['post_get_models', 'manufacturer_id'],
    generations: ['post_get_generations', 'model_id'],
    chassis: ['post_get_chassis', 'generation_id'],
    'rim-sizes': ['post_get_chassis_rim_sizes', 'chassis_id'],
};

window.boughtoLookup = function (kind, id, options) {
    const key = kind + ':' + id;

    if (!boughtoLookups.has(key)) {
        const [action, param] = boughtoLookupActions[kind];
        const ajax = () => jQuery.ajax({url: boughto.ajax_url, data: {action, [param]: id}, dataType: 'json'});
        // A page cached before 5.4.0 has no rest_url, only the old ajax_url.
        const request = (boughto.rest_url
            ? jQuery.ajax({url: boughto.rest_url + 'vehicles/' + kind + '/' + id, dataType: 'json'}).then(null, ajax)
            : ajax())
            .then((response) => response && response.success ? response : jQuery.Deferred().reject())
            .fail(() => boughtoLookups.delete(key));

        boughtoLookups.set(key, request);
    }

    if (options.beforeSend) options.beforeSend();

    return boughtoLookups.get(key).done(options.success).fail(options.error);
};
